export default {
    feedback: {
        title: 'Feedback',

        tableHeaders: [
            { text: 'Date', value: 'commentedAt', sortable: false },
            { text: 'Member Name', value: 'fullName', sortable: false },
            { text: 'Comment', value: 'comment', sortable: false },
            { text: 'Rating', value: 'rating', sortable: false }
        ]
    }
};
